module.exports = __webpack_public_path__ + "img/add-file.abe590d6.png";